import { useState } from 'react'
import './Events.css'

import Event from '../../Components/Event/Event'
import SEO from '../../Components/SEO/SEO';
import PageTitle from '../../Hooks/PageTitle';

import thesis_defense from '../../Media/Events.Media/thesis_defense.jpg'
import rub_internship from '../../Media/Events.Media/rub_internship.jpg'
import competition_fmpm from '../../Media/Events.Media/competition_fmpm.jpg'
import conference_fmpm from '../../Media/Events.Media/conference_fmpm.jpg'
import hackathon_ensas from '../../Media/Events.Media/hackathon_ensas.jpg'
import robovation from '../../Media/Events.Media/robovation.jpg'
import business_conference from '../../Media/Events.Media/business_conference.jpg'
import hackai from '../../Media/Events.Media/hackai.jpg'
import ai_conference from '../../Media/Events.Media/ai_conference.jpg'
import enactus_x_noi from '../../Media/Events.Media/enactus_x_noi.jpg'
import hackathon_semet27 from '../../Media/Events.Media/hackathon_semet27.jpg'
import poster_semet27 from '../../Media/Events.Media/poster_semet27.jpg'
import chess_semet27 from '../../Media/Events.Media/chess_semet27.jpg'
import project_exhi2_img from '../../Media/Events.Media/project_exhi2_semet27.jpg'
import project_exhi1_img from '../../Media/Events.Media/project_exhi1_semet27.jpg'
import tournoi_foot_semet27 from '../../Media/Events.Media/tournoi_foot_semet27.jpg'
import mon_master_semet27 from '../../Media/Events.Media/mon_master_semet27.jpg'
import robotics_club_opening from '../../Media/Events.Media/robotics_club_opening.jpg'
import graduation from '../../Media/Events.Media/graduation.jpg'

const Events = () => {
    PageTitle('Events');
	const [selectedType, setSelectedType] = useState('All Types');
	const [selectedPlace, setSelectedPlace] = useState('All Places');
	const [selectedDate, setSelectedDate] = useState('All Years');

	const handleFilterChange = (event, setter) => {
		setter(event.target.value);
	};

	const filterEvents = (event) => {
		const typeMatch = selectedType === 'All Types' || event.type === selectedType;
		const placeMatch = selectedPlace === 'All Places' || event.place === selectedPlace;
		const dateMatch = selectedDate === 'All Years' || event.date === selectedDate;

		return typeMatch && placeMatch && dateMatch;
	};

	const events = [
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1qUa0PE09uiGAOSwfQjnJmUwRJ72JuTAN?usp=sharing', '_blank'),
			date:'2026',
			image:thesis_defense,
			type:'Graduation',
			place:'FS Marrakesh',
			title:"Master's Thesis Defense",
			description:"Defended the Master's thesis on an ADAS-inspired navigation management system, using three independent parallel pipelines to minimize sensor input and mitigate LLM hallucination through modular, inspectable components rather than a monolithic VLM/VLA architecture.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1jrb4FxpztVcr6xsx7QT_xvV3Th8shtp4?usp=sharing', '_blank'),
			date:'2026',
			image:rub_internship,
			type:'Internship',
			place:'RUB Germany',
			title:"AI Research Internship at RUB",
			description:"Conducting research at Ruhr University Bochum on integrating Vision-Language-Action models into robotic systems. The project focuses on enabling autonomous navigation for an RC vehicle by combining camera streams, sensor data, and contextual prompts to generate driving actions in real time.",
			location:'Ruhr University Bochum, Germany',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1-wkKgKGSfsKnFpqNaspPa4ns8h9ubGZ0?usp=sharing', '_blank'),
			date:'2025',
			image:competition_fmpm,
			type:'Competition',
			place:'FMP Marrakesh',
			title:"Scientific Poster FMPM Competition",
			description:"Presented PulseX at a scientific poster competition held at the Faculty of Medicine and Pharmacy, Marrakesh. Showcased the AI-powered heart monitoring system and received the award for Best Scientific Poster among innovative health-tech projects.",
			location:'Faculty of Medicine and Pharmacy, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1ppylxCf7ZLapDiL0BtySfXV0bLkmcM92?usp=sharing', '_blank'),
			date:'2025',
			image:conference_fmpm,
			type:'Conference',
			place:'FMP Marrakesh',
			title:"AI & Telemedicine Conference",
			description:"Attended a conference at the Faculty of Medicine and Pharmacy, Marrakesh, exploring the integration of AI and embedded systems in modern healthcare. Discussed remote diagnostics, smart medical devices, and the future of tech-driven telemedicine solutions.",
			location:'Faculty of Medicine and Pharmacy, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1whrDOChnXETnBegrWzL0AmagRoC6dhXe?usp=sharing', '_blank'),
			date:'2025',
			image:hackathon_ensas,
			type:'Hackathon',
			place:'ENSA Safi',
			title:"Hackathon ENSA Safi",
			description:"Joined the ENSAS Hackathon in Asfi to solve a real-world industry challenge: detecting anomalies in sardine cans using image data. Built a deep learning model to identify improperly sealed cans and presented our solution to food-tech professionals.",
			location:'National School of Applied Sciences, Safi',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1fuJKaLaQDCPXz15guAK06sYNHWzRqH9H?usp=sharing', '_blank'),
			date:'2025',
			image:robovation,
			type:'Competition',
			place:'IC Marrakesh',
			title:"Robovation Competition",
			description:"Participated in the Robovation Competition at IC Marrakesh, where teams showcased robotics prototypes in front of a jury of 4 experts. Presented an AI-driven robotic system, gained valuable feedback, and explored cutting-edge trends in robotics innovation.",
			location:'Innovation City, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1OPh5knAQsWfrC2UaolJCImCYZK2kN0iU?usp=sharing', '_blank'),
			date:'2025',
			image:business_conference,
			type:'Conference',
			place:'IC Marrakesh',
			title:"Robovation Business Conference",
			description:"Attended a Business Conference at IC Marrakesh focused on entrepreneurial mindset and practical insights for the tech industry. Connected with business leaders, explored strategies for innovation, and gained valuable perspectives on startup and market trends.",
			location:'Innovation City, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1Gw4O8Jm570Ykv7CaM6ktDiebYmuFDKwA?usp=sharing', '_blank'),
			date:'2025',
			image:hackai,
			type:'Hackathon',
			place:'UM6P Ben Guerir',
			title:"Hackathon 1337 HackAI",
			description:"Secured 6th place out of 25 teams at HackAI Hackathon hosted by 1337 at UM6P. Spent 4 days immersed in GenAI challenges — building a heart health monitoring system powered by AI and IoT. Gained hands-on experience, while pushing the boundaries of innovation and teamwork.",
			location:'Mohammed VI Polytechnic University, Ben Guerir',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1vxYhI4zSCVbFaPyYyDfgQxNgJx4Nygg7?usp=sharing', '_blank'),
			date:'2025',
			image:ai_conference,
			type:'Conference',
			place:'UM6P Ben Guerir',
			title:"1337 AI Conference",
			description: "Attended an insightful AI Conference at UM6P, featuring discussions on the latest advancements in artificial intelligence, including GenAI, machine learning, and real-world applications across various industries. Explored emerging trends and connected with leading experts in the field.",
			location:'Mohammed VI Polytechnic University, Ben Guerir',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1QaCSkit5mme2VU-5J5r8Echse7nhPzrD?usp=sharing', '_blank'),
			date:'2025',
			image:enactus_x_noi,
			type:'Other',
			place:'FS Marrakesh',
			title:"ENACTUS X NOI",
			description:"Participated in an event organized by ENACTUS and NOI Clubs, where teams showcased innovative projects and products to visiting entrepreneurs. Presented our work, received feedback from professionals, and explored entrepreneurial perspectives on tech-driven solutions.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1t9GpzWULYQDs8qDzOmNuQ6hkmUNxbIFi?usp=sharing', '_blank'),
			date:'2025',
			image:hackathon_semet27,
			type:'Hackathon',
			place:'FS Marrakesh',
			title:"Hackathon SEMET'27",
			description:"Participated in SEMET'27 Hackathon focused on sustainability and water durability. As part of a 5-member team, we developed AquaBot — an AI-powered water management solution. Our project secured 2nd place among several competing teams.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1-NLKEazRTXcf_QIwR5xPMhPvkwKNMYbW?usp=sharing', '_blank'),
			date:'2025',
			image:poster_semet27,
			type:'Competition',
			place:'FS Marrakesh',
			title:"Poster Competition SEMET'27",
			description:"Competed in a poster competition with NeuroDrive — our intelligent vehicle automation project. Collaborated with teammate Zahra Abouhane to showcase its dual-system design. We achieved 5th place among numerous innovative entries.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1Cfcuq0n_k5NQa58fKfG5BOwF_H9M4xuK?usp=sharing', '_blank'),
			date:'2025',
			image:project_exhi2_img,
			type:'Other',
			place:'FS Marrakesh',
			title:'Projects Exhibition 2',
			description:"Took part in a follow-up AI project exhibition focused on detailed evaluation and feedback. A different panel of professors attended, including a senior research advisor, to assess the technical depth and practical relevance of our projects.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1h77Mk6TfwWJeFXvBpqTg9SNI8asR6F9d?usp=sharing', '_blank'),
			date:'2025',
			image:project_exhi1_img,
			type:'Other',
			place:'FS Marrakesh',
			title:'Projects Exhibition 1',
			description:"Participated in a university exhibition where we showcased our AI projects and prototypes. Engaged with the faculty dean, university president, and professors while presenting our work, explaining its real-world applications, and discussing its future development potential.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},		
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1AsBbWlh1MM__AueCKPSFmsSCnQlWwPdq?usp=sharing', '_blank'),
			date:'2025',
			image:chess_semet27,
			type:'Chess',
			place:'FS Marrakesh',
			title:"Chess SEMET'27",
			description:"Participated in the university chess tournament held at Semlalia in the SEMET'27 as it was my favorite mind-game. Competed against skilled players across multiple rounds. Gained valuable strategic experience and represented my skills with focus and resilience.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1xubl0NM95NNy1Yb-1k4xDyya4kGCpjUv?usp=sharing', '_blank'),
			date:'2025',
			image:tournoi_foot_semet27,
			type:'Sport',
			place:'FST Marrakesh',
			title:"Soccer Tournament SEMET'27",
			description:"Joined the university soccer tournament as part of a 5-player team. Competed in several intense matches showcasing teamwork, agility, and strategic play. Represented our department with pride and built strong team dynamics throughout the event.",
			location:'Faculty of Sciences and Technology, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1KVooKyChUXLwImgXoTlbWmpRS2CtfZye?usp=sharing', '_blank'),
			date:'2025',
			image:mon_master_semet27,
			type:'Competition',
			place:'FS Marrakesh',
			title:"Masters Competition SEMET'27",
			description:"Took part in a master's program competition where we presented our AI master, its curriculum, strengths, and future prospects. Collaborated with classmates to highlight its uniqueness and impact. Gained public speaking and academic presentation skills.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/1HR1-ZFe7K8cxO08D5EcrI6CHtHbaMq01?usp=sharing', '_blank'),
			date:'2025',
			image:robotics_club_opening,
			type:'Other',
			place:'FS Marrakesh',
			title:"Robotics Club Opening Day",
			description:"Participated in the launch event of the Robotics Club, where we showcased our innovative projects and working prototypes. Engaged with attendees, shared technical insights, and welcomed new members passionate about robotics and embedded systems.",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
		{
			onClick:() => window.open('https://drive.google.com/drive/folders/16DyIJVb2QojRDxredfbn4Wl4NPF5LnkX?usp=sharing', '_blank'),
			date:'2024',
			image:graduation,
			type:'Graduation',
			place:'FS Marrakesh',
			title:"Bachelor's Graduation Ceremony",
			description:"Celebrated the culmination of our undergraduate journey in Mathematics and Computer Science. Marked this milestone alongside my project partner and our supervisor, reflecting on years of academic growth, collaboration, and achievement. A proud moment!",
			location:'Faculty of Sciences Semlalia, Marrakesh',
		},
	];

	return (
		<>
			<SEO 
                title="Events"
                description="Participation in tech events, hackathons, AI competitions, and developer conferences. Experience in collaborative problem-solving, innovation challenges, and community engagement in Morocco's tech scene."
                url="https://yassinebazgour.vercel.app/Events"
                keywords="hackathons, tech events, AI competitions, developer conferences, coding competitions, innovation challenges, tech community Morocco, Marrakech tech events"
            />
			<section className='events-section'>
				<span className='events-title'>Events</span>
				<span className='events-description'>A list of events I've participated in, attended, or contributed to.</span>
				<span className='events-count-span'>
                    Attended Events:
                    <span className='events-count-number'> {events.filter(e => e.image).length}</span>
                </span>
				<div className='events-selects-container'>
					<select className='events-select events-type-select' onChange={(e) => handleFilterChange(e, setSelectedType)}>
						<option>All Types</option>
						<option>Hackathon</option>
						<option>Competition</option>
						<option>Conference</option>
						<option>Graduation</option>
						<option>Internship</option>
						<option>Chess</option>
						<option>Sport</option>
						<option>Other</option>
					</select>
					<select className='events-select events-place-select' onChange={(e) => handleFilterChange(e, setSelectedPlace)}>
						<option>All Places</option>
						<option>RUB Germany</option>
						<option>FS Marrakesh</option>
						<option>FST Marrakesh</option>
						<option>IC Marrakesh</option>
						<option>UM6P Ben Guerir</option>
						<option>ENSA Safi</option>
						<option>FMP Marrakesh</option>
					</select>
					<select className='events-select events-date-select' onChange={(e) => handleFilterChange(e, setSelectedDate)}>
						<option>All Years</option>
						<option>2026</option>
						<option>2025</option>
						<option>2024</option>
					</select>
				</div>
				<div className='events-container'>
					{events.filter(filterEvents).length === 0 ? (
						<span className='no-available-event'>No events are available for the selected filters. 😔</span>
					) : (
						events.filter(filterEvents).map((event, index) => (
							<Event 
								key={index}
								{...event}
							/>
						))
					)}
					</div>

			</section>
		</>
	)
}

export default Events
